// extracted by mini-css-extract-plugin
export default {"gallery-box":"ProjectDetail_gallery-box__DUKAt"};